import { selectors } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { FetchStatuses } from 'builder/modules/constants'
import { useAutoTailoring } from 'builder/components/AutoTailoring/hooks/useAutoTailoring'
import { NoDataStep } from './steps/NoDataStep/NoDataStep'
import { EnterLinkStep } from './steps/EnterLinkStep/EnterLinkStep'
import { LinkProcessingStep } from './steps/LinkProcessingStep/LinkProcessingStep'
import { ConfirmTailoringStep } from './steps/ConfirmTailoringStep/ConfirmTailoringStep'
import { JobPostingAttachedStep } from './steps/JobPostingAttachedStep/JobPostingAttachedStep'
import { ManualInputStep } from './steps/ManualInputStep/ManualInputStep'
import { KeywordsStep } from './steps/KeywordsStep/KeywordsStep'
import { JobPostingProps } from './types'

export const JobPostingForEditorWithTabs = (props: JobPostingProps) => {
  const { fetchScoreStatus, jobPostingAPIData, showManualInputScreen } = useTypedSelector(
    selectors.optimizerSection,
  )
  const autoTailoringOpenedModal = useTypedSelector(selectors.autoTailoringOpenedModal)
  const { isDataMissed } = useAutoTailoring()

  if (autoTailoringOpenedModal === 'keywords_selection') {
    return <KeywordsStep {...props} />
  }

  if (jobPostingAPIData.jobPostingId) {
    return <JobPostingAttachedStep {...props} />
  }

  if (isDataMissed) {
    return <NoDataStep {...props} />
  }

  if (showManualInputScreen) {
    return <ManualInputStep {...props} />
  }

  if (fetchScoreStatus === FetchStatuses.loading) {
    return <LinkProcessingStep {...props} />
  }

  if (fetchScoreStatus === FetchStatuses.loaded) {
    return <ConfirmTailoringStep {...props} />
  }

  return <EnterLinkStep {...props} />
}
